// TestPrintPreviewMobile.jsx
import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from '@mui/material';
import PrintPage from './PrintPage';

export default function TestPrintPreviewMobile({ open, onClose }) {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xl">
      <DialogTitle>Print Preview</DialogTitle>
      <DialogContent>
        <div
          style={{
            display: 'flex',
            gap: '20px',
            justifyContent: 'center',
            padding: '20px',
            transform: 'scale(0.75)',
            transformOrigin: 'top center',
          }}
        >
          <PrintPage>
            <h2>Page 1</h2>
            <p>This is the content for the first page...</p>
          </PrintPage>

          <PrintPage>
            <h2>Page 2</h2>
            <p>This is the content for the second page...</p>
          </PrintPage>
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
        <Button onClick={() => window.print()} variant="contained">
          Print
        </Button>
      </DialogActions>
    </Dialog>
  );
}



